"use client";

// Components
export { Gltf } from './components/Gltf.tsx';
export type { GltfProps } from './components/Gltf.tsx';
export { Modify } from './components/Modify.tsx';

// Hooks
export { useEntity } from './hooks/use-entity.ts';

// Types
export type {
  Rule,
  Action,
  MergedRule,
  ModifyNodeProps,
  ModifyLightProps,
  ModifyRenderProps,
  ModifyCameraProps
} from './types';

export type { PathPredicate, EntityMetadata } from './utils/path-matcher.ts';

